import {css} from 'lit';
export const styles = css`:host {
  --loader-index: 40;
  --new-messages-indicator-index: 30;
  --date-separator-index: 20;
  --fade-index: 10;

  display: block;
  position: relative;
  flex: 1 1 auto;
  height: 100%;
  min-height: 1px;
  padding-top: var(--chat-list-padding-block);
  padding-bottom: var(--chat-list-padding-block);
  border-width: var(--chat-list-border-width);
  background-color: var(--chat-list-background);
  border-style: solid;
  border-color: var(--chat-list-border-color);
  border-radius: var(--chat-list-border-radius);
}

ef-scroller {
  position: relative;
}

ef-scroller::before,
ef-scroller::after {
  content: '';
  position: absolute;
  left: 0;
  width: 100%;
  height: 8px;
  z-index: var(--fade-index);
}

ef-scroller::before {
  top: 0;
  background: var(--chat-list-fade-top);
}

ef-scroller::after {
  bottom: 0;
  background: var(--chat-list-fade-bottom);
}

:host([scrolling]) .message-date-separator {
    position: -webkit-sticky;
    position: sticky;
  }

.main {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  min-height: 100%;
  padding-left: var(--chat-list-padding-inline);
  padding-right: var(--chat-list-padding-inline);
}

.loader {
  position: absolute;
  top: 8px;
  left: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--chat-loader-size);
  height: var(--chat-loader-size);
  background-color: var(--chat-loader-background);
  border-radius: 50%;
  border: var(--chat-loader-border);
  color: var(--chat-loader-color);
  font-size: calc(var(--chat-loader-size) / 2);
  opacity: 0.7;
  transform: translateX(-50%);
  z-index: var(--loader-index);
}

.loader ef-icon {
    animation: spin 1.5s cubic-bezier(0.5, 0.2, 0.3, 0.5) infinite;
  }

.no-more-messages {
  align-self: center;
  margin-top: 16px;
  margin-bottom: auto;
  padding-bottom: 32px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}

.new-messages-indicator {
  position: absolute;
  top: 16px;
  left: 50%;
  align-self: center;
  padding: var(--chat-indicator-new-padding);
  background-color: var(--chat-indicator-new-background);
  border: none;
  border-radius: var(--chat-indicator-new-border-radius);
  color: var(--chat-indicator-new-color);
  font-size: var(--chat-indicator-new-font-size);
  text-transform: uppercase;
  transform: translateX(-50%);
  transition: filter var(--transition-timing), var(--transition-duration);
  z-index: var(--new-messages-indicator-index);
}

@media (hover: hover) {
    .new-messages-indicator:hover {
      filter: brightness(0.93);
    }
  }

.new-messages-indicator:active {
    filter: none;
  }

.new-messages-indicator ef-icon {
    margin-left: 2px;
  }

.unread-messages-indicator {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  width: var(--chat-indicator-unread-width);
  padding: var(--chat-indicator-unread-padding);
  background-color: --var(--dark);
  background-color: var(--chat-indicator-unread-background, --var(--dark));
  border-bottom-left-radius: var(--chat-indicator-unread-border-radius);
  border-bottom-right-radius: var(--chat-indicator-unread-border-radius);
  z-index: var(--new-messages-indicator-index);
  overflow: hidden;
  text-align: center;
  color: var(--chat-indicator-unread-color);
  font-size: var(--chat-indicator-unread-font-size);
}

.unread-messages-indicator > div:first-child {
    margin-right: auto;
  }

.unread-messages-indicator + .new-messages-indicator {
    top: 42px;
  }

.unread-messages-indicator button {
    color: inherit;
    background-color: transparent;
    border: none;
    text-decoration: underline;
    transition: filter var(--transition-timing), var(--transition-duration);
  }

@media (hover: hover) {
      .unread-messages-indicator button:hover {
        filter: brightness(0.93);
      }
    }

.unread-messages-indicator button:active {
      filter: none;
    }

.unread-messages-indicator ef-icon {
    margin-right: 2px;
  }

.message-system,
.separator {
  align-self: center;
  max-width: 80%;
  margin-top: 8px;
  margin-bottom: 8px;
  padding: 4px 8px;
  border-radius: var(--chat-separator-border-radius);
  text-align: center;
  font-size: 12px;
  font-weight: 600;
}

.separator {
  text-transform: uppercase;
}

.message-date-separator {
  top: 8px;
  background-color: var(--chat-separator-date-background);
  color: var(--chat-separator-date-color);
  z-index: var(--date-separator-index);
  min-width: 80px;
  text-align: center;
}

.message-unread-separator {
  background-color: var(--chat-separator-unread-background);
  color: var(--chat-separator-unread-color);
  scroll-margin: 38px; /* message-date-separator height + margin */
}

.message-system {
  background-color: var(--chat-msg-system-background);
  color: var(--chat-msg-system-color);
}

@keyframes spin {
  from {
    transform: rotate(-45deg);
  }

  to {
    transform: rotate(315deg);
  }
}
`;
export default styles;
